/**
 * Short relative-time formatter for sidebar timestamps and log lines.
 * Returns "just now", "5m ago", "3h ago", "2d ago", or a locale date for older.
 */
export function timeAgo(dateInput) {
  if (!dateInput) return "never";
  const then = new Date(dateInput).getTime();
  if (Number.isNaN(then)) return "never";

  const diff = Date.now() - then;
  const sec = Math.floor(diff / 1000);
  if (sec < 45) return "just now";
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const day = Math.floor(hr / 24);
  if (day < 30) return `${day}d ago`;
  return new Date(dateInput).toLocaleDateString();
}

/**
 * Number of days in the active dashboard date range, derived from the URL's
 * ?from=/?to= params (set by DateRangePicker; the API applies the same
 * range). No explicit range means the backend default — 28 days — so card
 * subtitles and header copy stay honest whichever preset is active.
 */
export function rangeDays(from, to) {
  if (!from) return 28;
  const start = new Date(from);
  const end = to ? new Date(to) : new Date();
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return 28;
  const days = Math.round((end.getTime() - start.getTime()) / 86400000);
  return days > 0 ? days : 28;
}

/** "Last 28 days" / "Last 7 days" / "Last 90 days" from the active range. */
export function rangeLabel(from, to) {
  return `Last ${rangeDays(from, to)} days`;
}
